/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
const now = () => (__SERVER__ ? Date.now() : global.performance.now());

export class RuntimePerformance {
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	startAt: any = now();

	start(): void {
		if (__SERVER__) {
			this.startAt = now();
		}
	}

	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	now(): any {
		if (__SERVER__) {
			return now() - this.startAt;
		}

		return now();
	}
}

export const performance: RuntimePerformance = new RuntimePerformance();
